import { useCookies } from './useCookies';

export const useIsCloudFrontViewerCountryUS = () => {
  const {
    cookies: { cloudfrontViewerCountry }
  } = useCookies();

  return cloudfrontViewerCountry === 'US';
};
